import React from 'react'
import styles from './ToggleSwitch.module.css'

// A small pill on/off switch (track + sliding knob), theme-aware. `tone`
// controls the "on" colour so it can match different surfaces.
const ToggleSwitch = ({
    checked = false,
    onChange = () => {},
    size = 'md',
    tone = 'blue',
    ariaLabel,
}) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        className={`${styles.switch} ${styles[size]} ${
            styles['tone_' + tone]
        } ${checked ? styles.on : ''}`}
        onClick={() => onChange(!checked)}
    >
        <span className={styles.knob} />
    </button>
)

export default ToggleSwitch
